export default __webpack_public_path__ + "118d9ecaf1bf03cfa1955f7f2bb0e28a.png";